<div class="library-wrapper">

  <div class="library-button quick-search">
    <div class="btn-text">
      <mat-icon svgIcon="search" matTooltip="Quick Search"></mat-icon>
      <input type='text' class='quick-search-input' #quickSearch placeholder='Quick Search'>
    </div>
  </div>
  <div class="sort-play-list pl-3 mt-2">
    <span matTooltip="By">By:</span>
    <select class="sort-selector" [(ngModel)]="playlistSortingMode">
      <option [value]="playlistSortingModes.SortByDateCreated">Date Created</option>
      <option [value]="playlistSortingModes.SortByPlaylistTitle">Title</option>
    </select>
  </div>

  <mat-expansion-panel class="library-panel" [expanded]="ui.isPlaylistPanelExpanded"
    (opened)="togglePlaylistPanel(true)" (closed)="togglePlaylistPanel(false)">
    <mat-expansion-panel-header>
      <mat-panel-title class="text-uppercase">
        Playlist Library
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="scroll-table" [class.opened-bottom-menu]="isBottomPanelVisible"
      [class.other-menu-closed]="!ui.isTagsPanelExpanded"
      [class.other-menu-closed-and-bottom-opened]="!ui.isTagsPanelExpanded && isBottomPanelVisible">

      <h2 class="left-menu-header location-playlist-header" matTooltip="List of all my playlists">my playlists</h2>
      <div cdkDropList #playlistList="cdkDropList" [cdkDropListData]="globalPlaylists"
        [cdkDropListConnectedTo]="availableConnectedIds">
        @let screensState = selectedScreensState;

        <playlist
          *ngFor="let playlist of globalPlaylists | playlistSort:playlistSortingMode | playlistFilter:quickSearch.value"
          [playlist]="playlist" [isAnyScreenPending]="screensState.isBusy"
          cdkDrag [cdkDragData]="{'data': playlist, 'type': libraryEditItemTypes.EditPlaylist}"
          (cdkDragStarted)="ui.handleItemlistDrag($event.source.data)" (cdkDragEnded)="ui.handleItemlistDrag(null)">
        </playlist>
        <playlist
          *ngFor="let playlist of localPlaylists | playlistSort:playlistSortingMode | playlistFilter:quickSearch.value"
          [playlist]="playlist" [isAnyScreenPending]="screensState.isBusy"
          cdkDrag [cdkDragData]="{'data': playlist, 'type': libraryEditItemTypes.EditPlaylist}"
          (cdkDragStarted)="ui.handleItemlistDrag($event.source.data)" (cdkDragEnded)="ui.handleItemlistDrag(null)">
        </playlist>
        <playlist
          *ngFor="let playlist of androidPlaylists | playlistSort:playlistSortingMode | playlistFilter:quickSearch.value"
          [playlist]="playlist" [isAnyScreenPending]="screensState.isBusy"
          cdkDrag [cdkDragData]="{'data': playlist, 'type': libraryEditItemTypes.EditPlaylist}"
          (cdkDragStarted)="ui.handleItemlistDrag($event.source.data)" (cdkDragEnded)="ui.handleItemlistDrag(null)">
        </playlist>
      </div>

      <h2 class="left-menu-header location-playlist-header" matTooltip="List of the Shared playlists">shared playlists
      </h2>
      <div cdkDropList #playlistList="cdkDropList" [cdkDropListData]="sharedPlaylists"
        [cdkDropListConnectedTo]="availableConnectedIds">
        <playlist
          *ngFor="let playlist of sharedPlaylists | playlistSort:playlistSortingMode | playlistFilter:quickSearch.value"
          [playlist]="playlist" cdkDrag [cdkDragData]="{'data': playlist, 'type': libraryEditItemTypes.EditPlaylist}"
          (cdkDragStarted)="ui.handleItemlistDrag($event.source.data)" (cdkDragEnded)="ui.handleItemlistDrag(null)">
        </playlist>
      </div>
    </div>

    <ng-container [ngTemplateOutlet]="addNew"
      [ngTemplateOutletContext]="{name:'Playlist', itemType:libraryEditItemTypes.EditPlaylist}">
    </ng-container>

  </mat-expansion-panel>

  <mat-expansion-panel class="library-panel" [expanded]="ui.isTagsPanelExpanded" (opened)="toggleTagPanel(true)"
    (closed)="toggleTagPanel(false)">
    <mat-expansion-panel-header>
      <mat-panel-title class="text-uppercase">
        Tags
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="scroll-table" [class.opened-bottom-menu]="isBottomPanelVisible"
      [class.other-menu-closed]="!ui.isPlaylistPanelExpanded"
      [class.other-menu-closed-and-bottom-opened]="!ui.isPlaylistPanelExpanded && isBottomPanelVisible">
      <app-tags></app-tags>
    </div>

    <ng-container [ngTemplateOutlet]="addNew"
      [ngTemplateOutletContext]="{name:'Tag', itemType:libraryEditItemTypes.EditTag}">
    </ng-container>

  </mat-expansion-panel>

</div>

<ng-template #addNew let-name="name" let-type="itemType">
  <div class="library-button button-create" (click)='createNewItem(type)'>
    <div class="btn-text">
      <mat-icon svgIcon="add" [matTooltip]="'Create New ' + name"></mat-icon>
      <span class="position-relative">Create New {{ name }}</span>
    </div>
  </div>
</ng-template>
